import BinaryReader from './BinaryReader'
import BinaryWriter from './BinaryWriter'
import NotifyMsgHeader from './NotifyMsgHeader'
import NotifyMsgTail from './NotifyMsgTail'
import Block from './Block'

const CMD_BROADCAST        = 1;    // 广播指令
const CMD_GET_SUBSCRIPT    = 2;    // 获取订阅数据库
const CMD_UPDATE_SUBSCRIPT = 3;    // 更新订阅数据库
const CMD_ADD_SUBSCRIPT    = 4;    // 添加订阅
const CMD_REMOVE_SUBSCRIPT = 5;    // 移除订阅
const CMD_UDP_PIPE         = 6;    // 建立 UDP 管道
const CMD_TCP_PIPE         = 7;    // 建立 TCP 管道

const NotifyMsg = function(opts = {}) {
    this.header = opts.header || new NotifyMsgHeader();  // 消息头
    this.key    = opts.key    || '';                     // Key
    this.blocks = opts.blocks || [];                     // 块列表
    this.tail   = opts.tail   || new NotifyMsgTail();    // 消息尾
};

NotifyMsg.CMD_BROADCAST        = CMD_BROADCAST;
NotifyMsg.CMD_GET_SUBSCRIPT    = CMD_GET_SUBSCRIPT;
NotifyMsg.CMD_UPDATE_SUBSCRIPT = CMD_UPDATE_SUBSCRIPT;
NotifyMsg.CMD_ADD_SUBSCRIPT    = CMD_ADD_SUBSCRIPT;
NotifyMsg.CMD_REMOVE_SUBSCRIPT = CMD_REMOVE_SUBSCRIPT;
NotifyMsg.CMD_UDP_PIPE         = CMD_UDP_PIPE;
NotifyMsg.CMD_TCP_PIPE         = CMD_TCP_PIPE;

const pt = NotifyMsg.prototype;

pt.writeMsg = function(writer) {
    const msg = this;
    msg.header.writeHeader(writer);
    writer.writeString(msg.key);
    const blocks = msg.blocks || [];
    for (let i = 0; i < blocks.length; i++) {
        blocks[i].writeBlock(writer);
    }
    msg.tail.writeTail(writer);
};

pt.readMsg = function (reader) {
    let msg = this;
    msg.header = NotifyMsgHeader.parseFromReader(reader);
    msg.key = reader.readString();
    msg.blocks = [];
    for (let i = 0; i < msg.header.blockCount; i++)
    {
        let block = Block.parseFromReader(reader);
        msg.blocks.push(block);
    }
    msg.tail = NotifyMsgTail.parseFromReader(reader);
};

// 构建 ArrayBuffer
pt.getArrayBuffer = function () {
    let capacity =
        NotifyMsgHeader.MSG_HEAD_SIZE +
        NotifyMsgTail.MSG_TAIL_SIZE +
        this.header.dataSize +
        BinaryWriter.getStringSize(this.key);
    let writer = new BinaryWriter(capacity);
    this.writeMsg(writer);
    return writer.buffer;
};

pt.firstBlock = function () {
    let blk;
    if (this.blocks && this.blocks.length > 0) {
        blk = this.blocks[0];
    }
    return blk;
}

// 获取命令的名称
NotifyMsg.getCmdName = function (cmd) {
    switch(cmd) {
        case CMD_BROADCAST:         return "广播指令";
        case CMD_GET_SUBSCRIPT:     return "获取订阅";
        case CMD_UPDATE_SUBSCRIPT:  return "更新订阅";
        case CMD_ADD_SUBSCRIPT:     return "添加订阅";
        case CMD_REMOVE_SUBSCRIPT:  return "移除订阅";
        case CMD_UDP_PIPE:          return "建立 UDP 管道";
        case CMD_TCP_PIPE:          return "建立 TCP 管道";
        default:                    return "未知指令(" + cmd + ")";
    }
};

NotifyMsg.parseFromReader = function (reader) {
    var msg = new NotifyMsg();
    msg.readMsg(reader);
    return msg;
};

NotifyMsg.parseFromArrayBuffer = function (arrayBuffer) {
    let reader = new BinaryReader(arrayBuffer);
    return NotifyMsg.parseFromReader(reader);
};

NotifyMsg.wrap = function (key) {
    let msg = new NotifyMsg();
    msg.header = new NotifyMsgHeader();
    msg.key = key;
    msg.blocks = [];
    msg.tail = new NotifyMsgTail();

    let dataSize = 0;
    for (let i = 1; i < arguments.length; i++) {
        let arg = arguments[i] || [];
        if (arg instanceof Block) {
            msg.blocks.push(arg);
            dataSize += arg.blockSize;
        }
        else {
            let zipMethod = arg.zipMethod;
            let data = arg.data ? arg.data : arg;
            var blk = Block.wrap(data, zipMethod);
            blk.id += i;
            msg.blocks.push(blk);
            dataSize += blk.blockSize;
        }
    }

    msg.header.dataSize = dataSize;
    msg.header.blockCount = msg.blocks.length;

    return msg;
};

export default NotifyMsg;
